import { useFactory, useRequiredContext, useTrackingAsync } from "@ispb/react-hooks"
import { maybe } from "shared/maybe"
import IconButton from "ui/components/IconButton"
import { SUCCESS_ICON } from "ui/icons"
import { Ramda } from "../namespaces/Ramda.js"
import { ExecutionStatus, getCanChangeControlPoint, getControlPointStatus, PublicProcedureContext, useAnonymous } from "./index.js"
import { cleanExecutionAction, EXECUTION_ACTION_FRAGMENT, PublicControlPoint, PublicExecution, PublicProcedure } from "./print.js"

interface ExecuteControlPointProps {

    readonly execution: PublicExecution
    readonly executionStatus: ExecutionStatus
    readonly procedure: PublicProcedure
    readonly controlPoint: PublicControlPoint
    readonly index: number

}

export default function ExecutionControlPoint(props: ExecuteControlPointProps) {
    const pin = useRequiredContext(PublicProcedureContext)
    const [anonymous] = useAnonymous()
    const status = useFactory(getControlPointStatus, [props.controlPoint.id, props.execution.actions])
    const canChange = useFactory(getCanChangeControlPoint, [props.controlPoint.id, props.index, props.procedure.controlPoints.map(_ => _.id), props.execution.actions, props.executionStatus])
    const mark = useTrackingAsync(async (status: boolean) => {
        const result = await pin.hasura.mutation({
            insertExecutionActionsOne: {
                __args: {
                    object: {
                        companyId: pin.data.companyId,
                        executionId: props.execution.id,
                        controlPointId: props.controlPoint.id,
                        anonymousName: anonymous?.name,
                        anonymousCompanyName: anonymous?.companyName,
                        status,
                    }
                },
                ...EXECUTION_ACTION_FRAGMENT
            }
        })
        const resultAction = maybe(result.insertExecutionActionsOne)
        pin.setData(data => {
            return {
                ...data,
                executions: data.executions.map(execution => {
                    return {
                        ...execution,
                        actions: Ramda.sortBy(_ => _.createdOn, [...execution.actions, cleanExecutionAction(resultAction)])
                    }
                })
            }
        })
    })
    return (
        <IconButton size="sm" onClick={() => mark.run(!status)} disabled={!canChange} busy={mark.isRunning} icon={SUCCESS_ICON} variant={status ? "danger" : "success"}>Mark as {status ? "Energized" : "Locked Out"}</IconButton>
    )
}
